module.exports = __webpack_public_path__ + "components/weather-icon/static/nightclear@3-cc81bfbdc689e909218af77e30dcbed5.png";